import React, { useMemo, useEffect, useState } from "react"

import { Container, CardBody, Card } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"

import { app_url } from "app_config"

import practice_logo from "../../assets/images/users/profile.png"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import moment from "moment"
import Loader from "components/Common/Loader"
import { setUpdatedData } from "helpers/data_setters"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const AllStaffs = () => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getStaff = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get("/employee-master")
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getStaff()
  }, [])

  document.title = "Employee Master | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}

      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Employee Master"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent
                table_data={table_data}
                settable_data={settable_data}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data, settable_data }) => {
  const navigate = useNavigate()

  const { checkAccess, permissions } = usePermissionData()
  const module_id = 4

  // change Status
  const handleStatus = async (status, id) => {
    try {
      if (status) {
        const response = await axiosbaseurl.patch(
          `/employee-master/${id}/status`,
          { status }
        )
        if (response.data.success)
          settable_data(prev =>
            setUpdatedData(prev, response.data.data, "edit", "Status ")
          )
      }
    } catch (error) {
      console.log(error)
    }
  }

  // delete records
  const handleDelete = async id => {
    try {
      const response = await axiosbaseurl.delete(`/employee-master/${id}`)
      if (response.data.success)
        settable_data(prev =>
          setUpdatedData(prev, response.data.data, "delete")
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "  text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      // {
      //   Header: "Profile Photo",
      //   accessor: "logo",
      //   disableFilters: true,
      //   filterable: true,
      //   className: "text-center",
      //   Cell: cellProps => {
      //     return (
      //       <div className="text-center">
      //         {/* <img src={practice_logo} alt="" className="rounded-circle" width={35} height={35} /> */}

      //         <img
      //           src={
      //             cellProps.row.original?.profilePhoto
      //               ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.profilePhoto}`
      //               : practice_logo // Fallback to default image
      //           }
      //           alt="img"
      //           className="rounded-circle"
      //           width={35}
      //           height={35}
      //         />
      //       </div>
      //     )
      //   },
      // },
      {
        Header: "Employee",
        accessor: "name",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center ">
              <div className="text-center employee-margin-right">
                <img
                  src={
                    cellProps.row.original?.profilePhoto
                      ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.profilePhoto}`
                      : practice_logo // Fallback to default image
                  }
                  alt="img"
                  className="rounded-circle"
                  width={35}
                  height={35}
                />
              </div>
              <div>
                {cellProps.row.original?.name}{" "}
                {cellProps.row.original?.lastName}
              </div>
            </div>
          )
        },
      },
      {
        Header: "Employee Email Address",
        accessor: "email",
        disableFilters: true,
        // className: "text-center",
        filterable: true,
      },
      {
        Header: "Employee Role",
        accessor: "roleId",
        disableFilters: true,
        // className: "text-center",
        filterable: true,
        Cell: cellProps => {
          return (
            <div>
              {cellProps.row.original?.role?.name
                ? cellProps.row.original?.role?.name
                : "N/A"}
            </div>
          )
        },
      },
      // {
      //   Header: "Contact Number",
      //   accessor: "contactNumber",
      //   disableFilters: true,
      //   filterable: true,
      //   className: " text-center",
      // },
      {
        Header: "Created At",
        disableFilters: true,
        filterable: true,
        // className: " text-center",
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </span>
          )
        },
      },
      {
        Header: "Status",
        disableSort: true,
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          // return (
          //     <div className="form-check form-switch form-switch-md ms-0 ps-3 mb-0 text-center">
          //         <input
          //             type="checkbox"
          //             className="form-check-input fs-2 ms-0 me-0 "
          //             style={{ left: 0 }}
          //             value={cellProps.row.original.status == "Active" ? "InActive" : "Active"}
          //             onChange={(e) => handleStatus(e.target.value, cellProps.row.original.id)}
          //             checked={cellProps.row.original.status == "Active"}
          //         />
          //     </div>
          // )

          return (
            <div className="text-center">
              <select
                onChange={e =>
                  handleStatus(e.target.value, cellProps.row.original.id)
                }
                disabled={!checkAccess(module_id, "edit")}
                className={`badge fs-6 border-0 status_select_dropdown 
                                    bg-${cellProps.row.original.status == "Active"
                    ? "green"
                    : "danger"
                  }`}
                value={cellProps.row.original.status}
              >
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
              </select>
            </div>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: "col-2 text-center",
        Cell: cellProps => {
          return (
            <div>
              {checkAccess(module_id, "edit") && (
                <Link
                  to={`${app_url}edit-employees/${cellProps.row.original.id}`}
                  className="btn btn-success bg-green  btn-sm me-2"
                >
                  <i className="fas fa-pen me-1"></i> Edit
                </Link>
              )}
              {checkAccess(module_id, "remove") && (
                <button
                  onClick={() =>
                    deleteNow(() => handleDelete(cellProps.row.original.id))
                  }
                  className="btn btn-danger btn-sm ml-10"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              )}
            </div>
          )
        },
      },
    ],
    [table_data, permissions]
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>

        <CommonTable
          columns={columns}
          data={data}
          heading={"Employees"}
        >

          <div>
            {checkAccess(module_id, "add") && (
              <Link
                to={`${app_url}add-employees`}
                className="btn btn-primary bg-blue ms-3"
              >
                <i className="fas fa-plus me-2"></i>
                Add Employee
              </Link>
            )}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>

        </CommonTable>

      </PermittedComponent>
    </>
  )
}

export default AllStaffs
